import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DesignatedUnitContributionDetailsFormGroup } from '../../../../../employers/add-employer/forms/designated-unit-contribution-details-form-group';
import { DropDownItem } from '../../../../../../models/shared/stylesheet/drop-down-item';

@Component({
  selector: 'app-create-designated-unit-employee-participation-form',
  templateUrl: './designated-unit-employee-participation-form.component.html',
  styleUrls: ['./designated-unit-employee-participation-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateDesignatedUnitEmployeeParticipationFormComponent {
  @Input() formGroup!: DesignatedUnitContributionDetailsFormGroup;
  @Input() formSubmitted: boolean = false;
  @Input() lessThanFullTimeParticipationDropdownItems!: DropDownItem[];

  public customErrorMessages = {
    fullTimeParticipationType: {
      required: $localize`Full time participation type required`
    },
    fullTimeWaitingPeriod: {
      required: $localize`Full time waiting period required`,
      max: $localize`Waiting period cannot exceed 24 months`
    },
    lessThanFullTimeParticipationTypeId: {
      required: $localize`Less than full time participation type required`
    },
    lessThanFullTimeWaitingPeriod: {
      required: $localize`Less than full time waiting period required`,
      max: $localize`Waiting period cannot exceed 24 months`
    }
  };
}
